// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"352":"06d352f9524bfbf2","894":"a2bfb92fe843c139"}[chunkId] + ".js";
};